import { render } from "./CreatePackageComponent.vue?vue&type=template&id=49941d6a"
import script from "./CreatePackageComponent.vue?vue&type=script&lang=js"
export * from "./CreatePackageComponent.vue?vue&type=script&lang=js"

import "./CreatePackageComponent.vue?vue&type=style&index=0&id=49941d6a&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__